import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import get from 'utils/get';

import { removeKeywords } from 'state/actions/backgroundLineActions';
import laureateStoryByTags from 'state/selectors/laureateStoryByTags';
import Lines from 'components/Lines';

const withLines = WrappedComponent => {
  class WithLines extends Component {
    constructor(props) {
      super(...arguments);

      this.state = {
        currentBlock: null,
        element: null,
        textContent: null,
        windowHeight: 0,
        positionIsMiddle: false
      };

      this.removeNoConnectionKeywords();

      this.ref = React.createRef();
      this.scrollTimer = null;
      this.resizeTimer = null;

      this.left = 0;
      this.top = 0;
      this.elementHeight = 0;
      this.elementWidth = 0;

      this.getPosition();
    }

    componentDidMount() {
      window.addEventListener('resize', this.getPositionWithResizeTimer);
      window.addEventListener('scroll', this.getPositionWithScrollTimer);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.getPositionWithResizeTimer);
      window.removeEventListener('scroll', this.getPositionWithScrollTimer);
    }

    getPositionWithScrollTimer = () => {
      if (this.scrollTimer !== null) {
        clearTimeout(this.scrollTimer);
      }
      this.scrollTimer = setTimeout(this.getPosition, 150);
    };

    getPositionWithResizeTimer = () => {
      this.setState({ positionIsMiddle: false });

      if (this.resizeTimer !== null) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(this.getPosition, 500);
    };

    removeNoConnectionKeywords = () => {
      const laureateStoryByTags = get(this, 'props.laureateStoryByTags', {});

      const noConnectionKeywords = Object.keys(laureateStoryByTags).filter(
        keyword => {
          return Object.keys(laureateStoryByTags[keyword]).length < 2;
        }
      );

      this.props.actions.removeKeywords(noConnectionKeywords);
    };

    setRef = ref => {
      if (ref) {
        const element = ref.getElementsByClassName('connected-with-lines')[0];

        if (element) {
          const elementInnerText = element.innerText.toLowerCase();
          const textContent = this.props.backgroundLineKeywords.find(
            keyword => {
              return elementInnerText.startsWith(keyword);
            }
          );

          const { currentLaureate } = this.props;
          const windowHeight = window.innerHeight;
          const refKey = `${currentLaureate}-${encodeURIComponent(
            textContent
          )}`;

          window.WINSTEM.refs = window.WINSTEM.refs || {};
          window.WINSTEM.refs[refKey] = ref;

          this.setState({
            currentBlock: ref,
            element,
            textContent: encodeURIComponent(textContent),
            windowHeight
          });
        }
      }
    };

    getPosition = () => {
      const { currentBlock, element } = this.state;

      if (currentBlock && element) {
        const elementBoundingClient = element.getBoundingClientRect();
        const positionIsMiddle = this.getBlockPosition(elementBoundingClient);
        if (
          positionIsMiddle &&
          this.state.positionIsMiddle !== positionIsMiddle
        ) {
          const scrollY = window.scrollY;
          const top = scrollY + elementBoundingClient.top;
          const left = elementBoundingClient.left;
          this.updateElementPosition(
            top,
            left,
            elementBoundingClient.height,
            elementBoundingClient.width
          );
        }

        this.setState({ positionIsMiddle });
      }
    };

    updateElementPosition = (top, left, height, width) => {
      if (this.top !== top || this.left !== left || this !== height) {
        this.top = top;
        this.left = left;
        this.elementHeight = height;
        this.elementWidth = width;
      }
    };

    getBlockPosition = elementBoundingClient => {
      const { windowHeight } = this.state;
      const top = elementBoundingClient.top;
      const elementMiddlePoint = top + elementBoundingClient.height / 2;

      if (
        elementMiddlePoint < windowHeight + windowHeight &&
        elementMiddlePoint > 0
      ) {
        return true;
      }
      return false;
    };

    render() {
      const {
        element,
        textContent,
        positionIsMiddle,
        windowHeight
      } = this.state;
      const {
        laureateStoryByTags,
        currentLaureate,
        breakpointData
      } = this.props;

      const currentTagLaureates = laureateStoryByTags[textContent];
      const selectedLaureates = !!currentTagLaureates
        ? Object.entries(currentTagLaureates).filter(
            ([slug, laureate]) => slug !== currentLaureate
          )
        : [];

      return (
        <Fragment>
          {!!element &&
            !!this.top &&
            !!this.left &&
            !!selectedLaureates.length && (
              <Lines
                positionIsMiddle={positionIsMiddle}
                top={this.top}
                left={this.left}
                elementHeight={this.elementHeight}
                elementWidth={this.elementWidth}
                selectedLaureates={selectedLaureates}
                tag={textContent}
                windowHeight={windowHeight}
                breakpointData={breakpointData}
              />
            )}
          <WrappedComponent {...this.props} setRef={this.setRef} />
        </Fragment>
      );
    }
  }

  const mapStateToProps = state => {
    return {
      laureateStoryByTags: laureateStoryByTags(state),
      backgroundLineKeywords: get(
        state,
        'backgroundLine.backgroundLineKeywords'
      )
    };
  };

  const mapDispatchToProps = dispatch => {
    return {
      actions: bindActionCreators({ removeKeywords }, dispatch)
    };
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(WithLines);
};

export default withLines;
